export default __webpack_public_path__ + "ad9167eb90004aba811f54aa87948609.gif";